import { ref } from 'vue'

const currentTheme = ref('default')

export function useTheme() {
  const switchTheme = (themeName) => {
    // 1. Enlever les anciennes classes de thème
    document.documentElement.className = ''
    
    // 2. Ajouter la nouvelle classe (ex: 'theme-y2k')
    if (themeName !== 'default') {
      document.documentElement.classList.add(`theme-${themeName}`)
    }
    
    currentTheme.value = themeName
    console.log(`Thème changé pour : ${themeName}`)
  }

  return {
    currentTheme,
    switchTheme
  }
}